<template>
  <div>
    <b-card>
      <vue-apex-charts
        type="bar"
        height="500"
        :options="chartOptions"
        :series="seriesData"
      />
    </b-card>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import { BCard } from 'bootstrap-vue'

export default {
  name: 'StackedBar',
  components: {
    BCard,
    VueApexCharts,
  },
  props: {
    isCard: {
      type: Boolean,
      default: true,
    },
    seriesData: {
      type: Array,
      required: true,
    },
    categoriesData: {
      type: Array,
      required: true,
    },
    titleText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      series: [{
        name: 'Chery',
        data: [44, 55, 41, 37, 22, 43, 21],
      }, {
        name: 'Citroen',
        data: [53, 32, 33, 52, 13, 43, 32],
      }, {
        name: 'Honda',
        data: [12, 17, 11, 9, 15, 11, 20],
      }, {
        name: 'Hyundai',
        data: [9, 7, 5, 8, 6, 9, 4],
      }, {
        name: 'Kia',
        data: [25, 12, 19, 32, 25, 24, 10],
      }],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 500,
          stacked: true,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              total: {
                enabled: true,
                offsetX: 0,
                style: {
                  fontSize: '13px',
                  fontWeight: 900,
                },
              },
            },
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '14px',
            fontWeight: 900,
          },
          total: {
            enabled: true,
          },
        },
        stroke: {
          width: 1,
          colors: ['#fff'],
        },
        title: {
          text: '',
        },
        xaxis: {
          categories: [],
          labels: {
            formatter(val) {
              return `${val}`
            },
          },
        },
        yaxis: {
          title: {
            text: 'Aylar',
          },
        },
        tooltip: {
          y: {
            formatter(val) {
              return `${val} adet`
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: 'top',
          horizontalAlign: 'center',
          offsetX: 0,
        },
      },
    }
  },
  watch: {
    seriesData: 'setData',
    categoriesData: 'setData',
    titleText: 'setData',
  },
  created() {
    this.setData()
  },
  methods: {
    setData() {
      this.series = this.seriesData
      this.chartOptions.xaxis.categories = this.categoriesData
      this.chartOptions.title.text = this.titleText
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
